import React, { useState } from 'react';
import { supabase } from '../../../../lib/supabase';
import EOIResponseFormModal from '../../../../components/EOIResponses/EOIResponseFormModal';
import type { EOIResponse } from '../../../../types/eoi-response';
import { useNavigate } from 'react-router-dom';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export default function AddEOIResponseModal({ isOpen, onClose, onSuccess }: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  // Default values for a new EOI Response
  const [initialData] = useState({
    reoi_eoi: '',
    reoi_app: '',
    reoi_application: '',
    reoi_date: new Date().toISOString().split('T')[0],
    reoi_success: 'P' // Default to "Not Yet Resolved"
  });

  const handleSubmit = async (data: Omit<EOIResponse, 'reoi_id'>) => {
    setIsSubmitting(true);
    setError(null);

    try {
      const { error } = await supabase
        .from('eoi_responses')
        .insert([data]);

      if (error) throw error;

      onSuccess();
      onClose();
      navigate('/admin/eoi-responses', { replace: true });
    } catch (err: any) {
      setError(err.message || 'An error occurred while adding the EOI response');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <EOIResponseFormModal
      isOpen={isOpen}
      onClose={onClose}
      initialData={initialData}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      error={error}
      title="Add EOI Response"
      submitLabel="Add Response"
    />
  );
}
